<template>
  <div class="mx-auto noto-sans-sc-font-family">
    <v-app-bar
      app
      flat
      id="mobile-nav-bar"
      height="85px"
      extension-height="65px"
    >
      <!-- 头部左边选项栏 -->
      <div class="nav-bar-left-container">
        <v-app-bar-nav-icon
          @click.stop="showHamburgerMenu = !showHamburgerMenu"
        ></v-app-bar-nav-icon>
      </div>

      <!-- 中间logo -->
      <div class="nav-bar-middle-container">
        <router-link to="/" class="d-md-flex ma-auto">
          <v-img
            class="ma-auto"
            :src="getImage('/others/1byone_logo.svg')"
            height="50px"
            width="90px"
            contain
          ></v-img>
        </router-link>
      </div>

      <!-- 右边图标 -->
      <div class="nav-bar-right-container">
        <div class="mobile-nav-right-item">
          <router-link
            to="/"
            class="icon-sprite mobile-nav-icon mobile-nav-icon-account d-block"
          ></router-link>
        </div>
      </div>

      <!-- 下面搜索框 -->
      <!-- <template v-slot:extension>
        <div id="navbar-search-mobile" class="mx-auto d-flex">
          <input
            id="search-box-mobile"
            class="search-box"
            type="text"
            placeholder="I am looking for...."
            v-model="searchKeywords"
            v-on:keyup.enter="performSearch"
          />
          <div id="navbar-search-button" class="icon-sprite" @click="performSearch"></div>
        </div>
      </template> -->
    </v-app-bar>

    <!-- 头部左边选项栏的具体栏 -->
    <v-navigation-drawer
      v-model="showHamburgerMenu"
      fixed
      temporary
      id="nav-bar-hamburger-menu"
    >
      <div id="hamburger-menu-items-container" class="mt-4">
        <div
          class="noto-sans-sc-font-family"
          v-for="(menuItem, index) in hamburgeMenuItems"
          :key="index"
        >
          <div
            class="hamburger-menu-item top-hamburger-menu-item text-uppercase"
          >
            <a v-if="menuItem.url" :href="menuItem.url">{{ menuItem.title }}</a>
            <div v-else>{{ menuItem.title }}</div>
          </div>
          <div v-if="menuItem.subMenu" id="hamburger-sub-menu-container">
            <div
              class="hamburger-menu-item hamburger-subMenu-item"
              v-for="(subMenuItem, index) in menuItem.subMenu"
              :key="index"
            >
              <a :href="subMenuItem.url">{{ subMenuItem.title }}</a>
            </div>
          </div>
        </div>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { getImage } from "../../api/dataFactory";
import navBarMixins from "../../mixins/navBarMixins";

export default {
  mixins: [navBarMixins],
  data: () => ({
    getImage,
    showHamburgerMenu: false,
    searchKeywords: "",
    hamburgeMenuItems: [
      {
        title: "healthy life",
        url: "/product/browse?c=health",
        subMenu: [
          {
            title: "Scales",
            url: "/product/browse?c=health&sc=scale",
          },
          {
            title: "Bottle",
            url: "/product/browse?c=health&sc=bottle",
          },
          {
            title: "Blood Pressure Monitor",
            url: "/product/browse?c=health&sc=bloodPressureMonitor",
          },
          {
            title: "TENS",
            url: "/product/browse?c=health&sc=tens",
          },
          {
            title: "ECG Monitor",
            url: "/product/browse?c=health&sc=ecgMonitor",
          },
          {
            title: "Oximeter",
            url: "/product/browse?c=health&sc=oximeter",
          },
          {
            name: "White Noise Machine",
            landingPage: "/product/browse?c=health&sc=whitenoiseMachine",
          },
          {
            name: "Resistance Band",
            landingPage: "/product/browse?c=health&sc=resistanceBand",
          },
        ],
      },
      {
        title: "all product",
        url: "/product/browse",
      },
      {
        title: "DOWNLOAD APP ",
        url: "/product/downloadMobile",
      },
      {
        title: "support",
        subMenu: [
          {
            title: "Warranty",
            url: "/support/warranty",
          },
        ],
      },
      // {
      //   title: "about us",
      //   url: "/support/about_us"
      // },
      // {
      //   title: "my account",
      //   url: "/ya/"
      // }
    ],
  }),

  methods: {
    performSearch() {
      window.location.href = this.searchUrl;
    },
  },

  computed: {
    searchUrl() {
      return "/search?k=" + this.searchKeywords;
    },
  },
};
</script>>

<style scoped>
#mobile-nav-bar >>> .v-toolbar__content {
  justify-content: space-between !important;
}

#navbar-search-mobile {
  width: 90%;
}

.search-box {
  width: 100%;
  padding: 10px;
  height: 50px;
  border: 1px solid #e6e6e6;
}

#navbar-search-button {
  border: 1px solid #e6e6e6;
  border-left: none;
  height: 50px;
  width: 60px;
  background-position: -65px 14px;
  background-size: 300px;
}

#navbar-search-mobile > input[type="text"] {
  display: inline-block;
  font-size: 16px;
}

#navbar-search-mobile > input[type="text"]:focus {
  border-color: #e2211c;
  outline: none !important;
}

.mobile-nav-icon {
  width: 40px;
  height: 60px;
}

.mobile-nav-icon.mobile-nav-icon-account {
  background-position: -50px 15px;
}

.hamburger-menu-item {
  width: 90%;
  margin: auto;
  padding-bottom: 10px;
  padding-top: 10px;
  border-bottom: solid 2px #e6e6e6;
}
.top-hamburger-menu-item a {
  color: #333333;
}

.hamburger-subMenu-item a {
  color: #666666;
}

.hamburger-subMenu-item {
  font-size: 14px;
}

.top-hamburger-menu-item {
  font-size: 15px;
  font-weight: 600;
}
</style>
